import { render } from "./AccommodationList.vue?vue&type=template&id=7d8faa81"
import script from "./AccommodationList.vue?vue&type=script&lang=js"
export * from "./AccommodationList.vue?vue&type=script&lang=js"

import exportComponent from "/home/undanet/pej22-webadmin/front-end/project/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__